<template>
    <div
        class="metric-slider display-flex align-items-center"
        :class="{ disabled: props.disabled }"
    >
        <p class="font-base mr-lg text-stone-800">{{ props.label }}</p>
        <div class="metric-slider__container">
            <div class="metric-slider__range" :style="rangeStyle">
                <div class="metric-slider__bullet"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    steps: {
        type: Number,
        default: 4,
    },
    value: {
        type: Number,
        default: 50,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const rangeStyle = computed(() => {
    const normalizedValue = Math.min(Math.max(props.value, 0), 100)
    const stepWidth = 100 / props.steps

    const position = (normalizedValue * (100 - stepWidth)) / 100

    return {
        width: `${stepWidth}%`,
        left: `${position}%`,
    }
})
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.metric-slider {
    p {
        text-wrap: nowrap;
    }

    &__container {
        width: 100%;
        min-width: 150px;
        height: 10px;
        border-radius: var(--border-radius-md);
        background: var(--color-stone-200);
        position: relative;
    }

    &__range {
        height: 100%;
        border-radius: var(--border-radius-md);
        background: var(--color-moat-600);
        position: absolute;
        top: 0;
    }

    &__bullet {
        width: 8px;
        height: 8px;
        background: var(--color-stone-500);
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
